import { Search } from "lucide-react";
import { Input } from "../ui/input";
import CatalogProductCard from "./CatalogProductCard";

// Renders the search input, the category-chips filter and the product grid.
// Keeps CatalogPanel free of inline JSX for that path.
export default function ProductsTab({
  search,
  onSearch,
  cat,
  onCat,
  categoryChips,
  filtered,
  supplierById,
  isMain,
  canEditProduct,
  onEdit,
  onAskDelete,
}) {
  return (
    <>
      <div className="relative mb-3">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#0B1F3A]/40" />
        <Input
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder="Search products…"
          className="pl-9 h-11 bg-white border-[#E6E0D4]"
        />
      </div>
      <div className="flex gap-2 overflow-x-auto pb-3 -mx-1 px-1">
        {categoryChips.map((c) => {
          const active = c === cat;
          return (
            <button
              key={c}
              onClick={() => onCat(c)}
              className={`shrink-0 h-9 px-4 rounded-full text-sm border transition-colors ${
                active
                  ? "bg-[#0B1F3A] text-white border-[#0B1F3A]"
                  : "bg-white text-[#0B1F3A] border-[#E6E0D4] hover:border-[#0B1F3A]/40"
              }`}
            >
              {c}
            </button>
          );
        })}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-4">
        {filtered.map((p) => (
          <CatalogProductCard
            key={p.id}
            product={p}
            supplier={supplierById(p.supplierId)}
            editable={canEditProduct(p)}
            isMain={isMain}
            onEdit={() => onEdit(p)}
            onAskDelete={() => onAskDelete(p)}
          />
        ))}
      </div>
      {filtered.length === 0 && (
        <div className="bg-white border border-[#E6E0D4] rounded-xl p-8 text-center mt-4">
          <p className="text-[#0B1F3A]/60 text-sm">No products match. Try another search or add a new one.</p>
        </div>
      )}
    </>
  );
}
